import * as yup from 'yup';

export const step1Schema = yup.object({
  templateId: yup.string().required('Please select a template'),
});

export const step2Schema = yup.object({
  instanceName: yup.string().required('Instance name is required'),
  deadlineDate: yup.date().required('Deadline date is required').nullable(),
  deadlineTime: yup.string().required('Deadline time is required'),
  reminderDate: yup
    .date()
    .nullable()
    .transform((v, o) => (o === '' || o == null ? null : v))
    .test('is-before-deadline', 'Reminder cannot be later than the deadline', function validate(value) {
      const { deadlineDate, deadlineTime, reminderTime } = this.parent;
      if (!deadlineDate || !deadlineTime || !value || !reminderTime) {
        return true; // Optional: skip when reminder empty
      }

      const getDateStr = (d: any) => {
        if (d instanceof Date) {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        if (typeof d === 'string' && d.includes('T')) return d.split('T')[0];
        return d;
      };

      const dDate = getDateStr(deadlineDate);
      const rDate = getDateStr(value);

      const deadline = new Date(`${dDate}T${deadlineTime}`);
      const reminder = new Date(`${rDate}T${reminderTime}`);

      return reminder <= deadline;
    }),
  reminderTime: yup
    .string()
    .nullable()
    .transform((v, o) => (o === '' ? null : v)),
});

export const step3Schema = yup
  .object({
    stepOverrides: yup.array().of(
      yup.object({
        originalStepId: yup.number().required(),
        included: yup.boolean().required(),
        mandatory: yup.boolean().required(),
      }),
    ),
  })
  .test(
    'at-least-one-included',
    'At least one step must be included',
    value => value?.stepOverrides?.some((o: { included?: boolean }) => o.included === true) ?? false,
  )
  .test(
    'at-least-one-mandatory',
    'At least one mandatory step is required to create an instance.',
    value =>
      value?.stepOverrides?.some((o: { included?: boolean; mandatory?: boolean }) => o.included === true && o.mandatory === true) ?? false,
  );

export const step4Schema = yup.object({
  selectedAssets: yup.array().min(1, 'Please select at least one asset').required('Assets are required'),
});

const actionLibraryInstanceValidationSchema = [step1Schema, step2Schema, step3Schema, step4Schema];

export default actionLibraryInstanceValidationSchema;
